import { CountryData } from '@components/country-code/types';
import { LEAD_NAME_MAX_LENGTH } from '@constants/generic';
import { isValidPhoneNumber } from '@helpers/generic';
import {
  getLeadNameValidationError,
  isInvalidLeadName
} from '@utils/validations';

import { MoveToCofeeContact } from './types';

export const isMoveToCofeeNameInvalid = (name: string): boolean =>
  isInvalidLeadName(name, LEAD_NAME_MAX_LENGTH);

export const getMoveToCofeeNameError = (name: string): string =>
  getLeadNameValidationError(name, LEAD_NAME_MAX_LENGTH);

export const isMoveToCofeeMobileInvalid = (
  mobileNumber: string,
  countryCode: string,
  supportedCountries: CountryData[]
): boolean => {
  const countryId = supportedCountries.find(
    (country) => `${country.dial_code}` === countryCode
  )?.code;
  return !isValidPhoneNumber(mobileNumber, countryId || '');
};

// Form country codes are stored without '+'; lead country codes may include it.
export const isLeadPhoneUnchanged = (
  contact: Pick<MoveToCofeeContact, 'mobileNumber' | 'countryCode'>,
  lead: { mobile_number?: string; country_code?: string }
): boolean =>
  contact.mobileNumber === (lead.mobile_number || '') &&
  contact.countryCode === (lead.country_code || '').replace('+', '');
